// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__24Db9","productName":"Table_productName__3-Kwc"};